module.exports = __webpack_public_path__ + "static/media/arcade-background.42bdc6b0.png";